import Auth from "@kinetics254/cassandra-base/modules/auth/middleware/Auth";
const AppDashboard = () =>
  import("@/packages/cassandra-base/app/layout/AppDashboard");

import Disciplinary from "./views/Grievances.vue";
import List from "./components/List.vue";
import AssignedGrievancesList from "./components/AssignedGrievancesList.vue";

export default [
  {
    path: "/grievances",
    component: AppDashboard,
    children: [
      {
        path: "",
        components: {
          view: Disciplinary,
        },
        children: [
          {
            path: "list",
            name: "List",
            components: {
              view: List,
            },
            meta: {
              middleware: [Auth],
            },
          },
          {
            path: "assigned",
            name: "Assigned",
            components: {
              view: AssignedGrievancesList,
            },
            meta: {
              middleware: [Auth],
            },
          },
        ],
      },
    ],
  },
];
